import * as yup from "yup";
import { CreateInterProcessorSingleTransfer } from "../../../../interfaces-and-types";

export const createInterProcessorSingleBankTransferSchema: yup.SchemaOf<CreateInterProcessorSingleTransfer> =
  yup
    .object({
      // actual transfer details
      reference: yup.string().required("Reference is required"),
      description: yup.string().nullable().optional().max(300),

      currency: yup.string().required("Currency is required"),
      amount: yup
        .number()
        .transform((_value, originalValue) =>
          !originalValue
            ? 0
            : Number(originalValue.toString().replace(/,/g, ""))
        )
        .required("Amount is required")
        .positive("Amount must be greater than zero"),
      top_up_wallet_details_id: yup
        .string()
        .required("top-up wallet id is required"),
      // bank_code: yup.string().required("Bank code is required"),
      account_number: yup.string().required("Account number is required"),

      source_gateway_code: yup.string().required("Source gateway is required"),
      recipient_gateway_code: yup
        .string()
        .required("Recipient gateway is required")
        .notOneOf(
          [yup.ref("source_gateway_code"), null],
          "Source & Destination Gateways must be different"
        ),

      // account verification beneficiary
      bank_name: yup.string().required("Bank name is required"),
      account_name: yup.string().required("Account name is required"),
    })
    .required();
